/**
 * dd-theme-interest-second.js — 「按旅游主题展示」二级页交互
 *
 * 职责（轻量，无依赖，失效静默）：
 *   1. 主题筛选：点击主题卡片，即时过滤下方产品（按 data-dd-theme）
 *   2. 锚点平滑滚动：Hero 按钮滚动到主题筛选区
 */

;(function () {
  'use strict'

  var wrap = document.querySelector('.dd-theme-filter')
  var cards = wrap ? wrap.querySelectorAll('[data-dd-theme-filter]') : []
  var items = document.querySelectorAll('.dd-theme-item')
  var countEl = document.querySelector('[data-dd-theme-count]')

  /* ------------------------------------------------------------------------
     平滑滚动（Hero 按钮）
     ------------------------------------------------------------------------ */
  var scrollLinks = document.querySelectorAll('a[data-dd-theme-scroll]')
  for (var i = 0; i < scrollLinks.length; i++) {
    scrollLinks[i].addEventListener('click', function (e) {
      var href = this.getAttribute('href')
      if (!href || href.charAt(0) !== '#') return
      var target = document.getElementById(href.slice(1))
      if (!target) return
      e.preventDefault()
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      if (history.replaceState) history.replaceState(null, '', href)
    })
  }

  if (!wrap || !cards.length) return

  /* ------------------------------------------------------------------------
     筛选逻辑
     ------------------------------------------------------------------------ */
  function setActive(key) {
    var visible = 0

    for (var i = 0; i < cards.length; i++) {
      var active = cards[i].getAttribute('data-dd-theme-filter') === key
      cards[i].classList.toggle('is-active', active)
      cards[i].setAttribute('aria-pressed', active ? 'true' : 'false')
    }

    for (var j = 0; j < items.length; j++) {
      var themes = (items[j].getAttribute('data-dd-theme') || '').trim()
      var show = key === 'all' || themes.split(/\s+/).indexOf(key) !== -1
      items[j].classList.toggle('is-hidden', !show)
      if (show) visible++
    }

    if (countEl) {
      countEl.textContent = visible === 1
        ? 'Showing 1 journey'
        : 'Showing ' + visible + ' journeys'
    }
  }

  for (var i = 0; i < cards.length; i++) {
    cards[i].addEventListener('click', function () {
      setActive(this.getAttribute('data-dd-theme-filter'))
    })
  }
})()
